const LOCATION_CACHE_KEY = 'cachedLocation'
const CACHE_EXPIRY_TIME = 24 * 60 * 60 * 1000 // 24 hours

export default {
    getCurrentPosition() {
        return new Promise((resolve, reject) => {
            const cachedData = this.getCachedLocation()
            const now = Date.now()

            if (cachedData && now - cachedData.timestamp < CACHE_EXPIRY_TIME) {
                resolve(cachedData.position)
            } else {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        // Cache the new position
                        localStorage.setItem(LOCATION_CACHE_KEY, JSON.stringify({ position, timestamp: now }))
                        resolve(position)
                    },
                    (error) => reject(error),
                )
            }
        })
    },

    getCachedLocation() {
        return JSON.parse(localStorage.getItem(LOCATION_CACHE_KEY))
    },
}
